function updateLine() {
    const content = document.querySelector('.monohydrate-fifth__content');
    const line = content.querySelector('.monohydrate-fifth__line');
    const card = content.querySelector('.monohydrate-fifth__card');

    if(card && line) {
        const cardHeight = card.offsetHeight;
        const offset = cardHeight / 2;

        line.style.top = offset + 'px';
        line.style.height = 'calc(100% - ' + cardHeight + 'px)';
    }
}

document.addEventListener('DOMContentLoaded', updateLine);
window.addEventListener('resize', updateLine);